import SvgCheckSolid from "./SvgCheckSolid";
import SvgXmarkSolid from "./SvgXmarkSolid";
import { PackageGridItemProps } from "../models/PropsInterface";
import "../cssStyles/PackageGridItem.css";
const PackageGridItem = (props: PackageGridItemProps) => {
  return (
    <div
      className={`vas-row package_grid_item__row vas-justify-content-center`}
    >
      <div className={`vas-col-9`}>
        <p
          className={`vas vas-mb-0 vas-mt-1 vas-pb-0 vas-fw-bold package_grid_item__font_size_title`}
        >
          {props.title}
        </p>
        <p
          className={`vas vas-mt-1 vas-mb-0 package_grid_item__font_size_desc`}
        >
          {props.desc}{" "}
        </p>
      </div>

      <div
        className={`vas-col-3 vas-p-0 package_grid_item__centered_text_grid_item`}
      >
        <div className={`vas-flex-grow-1`}>
          {["Yes", "No"].includes(props.pillText) ? (
            props.pillText === "No" ? (
              <SvgXmarkSolid />
            ) : (
              <SvgCheckSolid />
            )
          ) : (
            ""
          )}
          {["Yes", "No"].includes(props.pillText) ? "" : props.pillText}
        </div>
      </div>

      <div className={`vas-col-12 vas-p-0`}>
        <div className={`package_grid_item__line_style`} />
      </div>
    </div>
  );
};

export default PackageGridItem;
